function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3602 16.5226C15.3602 17.1208 14.8753 17.6057 14.2771 17.6057H2.36334C1.76518 17.6057 1.28027 17.1208 1.28027 16.5226V2.44269C1.28027 1.84453 1.76518 1.35962 2.36334 1.35962H10.038C10.325 1.35968 10.6003 1.47369 10.8034 1.6766L15.0432 5.91646C15.2461 6.1195 15.3601 6.39478 15.3602 6.68183V16.5226Z",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3597 6.77498H11.0274C10.4292 6.77498 9.94434 6.29007 9.94434 5.6919V1.35962",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.16016 10.9598H12.4802",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.16016 14.2584H12.4802",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67984 4.7388V3.9198H5.82564V4.72813H6.11492L5.5423 5.39542H5.30518V4.72813H5.63121V3.9198H5.19137V4.22322H4.95308V3.9198H4.51798V4.22322H4.27968V3.9198H3.83984V4.7388H4.2287V5.7581V6.77741H3.83984V7.5964H5.63121V6.78807H5.30518V6.12078H5.5423L6.11492 6.78807H5.82564V7.5964H7.67984V6.77741H7.39176L6.518 5.7581L7.39176 4.7388H7.67984Z",
  fill: "#4C4C4C"
});

const SvgGrant = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "grant-icon",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grant.a2470e5d.svg";
export { ForwardRef as ReactComponent };